// extracted by mini-css-extract-plugin
export default {"attention":"Attention_attention__zBY9Q"};